<template>
    <div :class="backgroundColor" class="flex h-9 w-9 items-center justify-center rounded-full border-1 border-[#D8d8d8] transition-colors">
        <slot name="icon">
            <timer-reset v-if="overdue" class="h-4 w-4" />
            <check v-else-if="success === true" />
            <icon v-else-if="success === false" name="cil-x" />
        </slot>
    </div>
</template>
<script setup>
import Check from '../../../icons/Check.vue';
import { TimerReset } from '@lucide/vue';
import { computed } from 'vue';

const props = defineProps({
    success: Boolean,
    overdue: Boolean,
    bgColor: {
        type: String,
        default: 'bg-green-light',
    },
});

const backgroundColor = computed(() => {
    if (props.success === true || props.success === false) {
        return props.bgColor;
    }

    return 'bg-white';
});
</script>
